import { useEffect } from 'react';
import './AuroraBackground.css';

/**
 * Background aurora partagé pour toutes les pages publiques.
 * Prop `dim` : atténue les auroras et fige les animations drift (pour pages de lecture longue).
 */
export default function AuroraBackground({ dim = false }) {
  useEffect(() => {
    document.body.classList.add('aurora-body');
    return () => document.body.classList.remove('aurora-body');
  }, []);

  return (
    <>
      <div className={'aurora-bg' + (dim ? ' aurora-bg-dim' : '')} aria-hidden="true">
        <span /><span /><span />
      </div>
      <div className="aurora-grain" aria-hidden="true" />
    </>
  );
}
